.cardLink {
    display: block;
    color: inherit;
    text-decoration: none;
}

/* the offset lives outside of AnimateWrapper, so the card is never cut by it */
.cardSlot {
    position: relative;
    margin: 50px 0;
}

.cardLeft {
    left: -30px;
}

.cardRight {
    left: 30px;
}

.workCard {
    width: 930px;
    height: 480px;
    border-radius: 2px;
    cursor: pointer;
    position: relative;
    -webkit-box-shadow: 0 2px 46px 13px rgba(0, 0, 0, 0.32);
    -moz-box-shadow: 0 2px 46px 13px rgba(0, 0, 0, 0.32);
    box-shadow: 0 2px 46px 13px rgba(0, 0, 0, 0.32);
    transition: 0.3s;
    overflow-x: hidden;
    overflow-y: hidden;
    -webkit-transition: 0.3s all ease;
}

.image {
    object-fit: cover;
    width: 100%;
    filter: brightness(75%);
    height: 100%;
}

/* dark only under the text, the rest of the cover stays bright */
.workCard:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events: none;
}

.cardLeft .workCard:after {
    background: linear-gradient(90deg, rgba(12, 13, 18, 0.92) 0%, rgba(12, 13, 18, 0.7) 35%, rgba(12, 13, 18, 0) 70%);
}

.cardRight .workCard:after {
    background: linear-gradient(270deg, rgba(12, 13, 18, 0.92) 0%, rgba(12, 13, 18, 0.7) 35%, rgba(12, 13, 18, 0) 70%);
}

.workCard:before {
    content: '';
    position: absolute;
    left: 0;
    transform: translateX(-100%);
    height: 100%;
    width: 100%;
    background-color: rgba(40, 61, 145, 0.85);
    transition: 0.4s all;
    -webkit-transition: 0.4s all ease;
    z-index: 2;
}

.workCard:hover {
    -webkit-box-shadow: 0 2px 70px 9px rgba(0, 0, 0, 0.53);
    -moz-box-shadow: 0 2px 70px 9px rgba(0, 0, 0, 0.53);
    box-shadow: 0 2px 70px 9px rgba(0, 0, 0, 0.53);
}

.workCard:hover:before {
    transform: translateX(0);
}

.textLeft, .textRight {
    position: absolute;
    top: 45%;
    z-index: 3;
    color: white;
    transition: transform 0.4s linear, opacity 0.4s linear;
    transform: scale(1);
    transition-delay: 0.4s;
    -webkit-transition: 0.4s ease-in-out;
}

.textLeft {
    left: 60px;
}

.textRight {
    right: 60px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.btnContainer {
    display: flex;
}

.cardTitle {
    font-size: 2.8em;
    margin: 0;
    font-family: var(--font-body);
    font-weight: 600;
}

.cardText {
    font-style: italic;
    font-weight: 500;
    font-size: 1.2em;
    margin: 5px 0 20px;
    font-family: var(--font-serif);
}

.workCard:hover .textLeft, .workCard:hover .textRight {
    transform: scale(1.1);
}

/* a fixed line-height: with "normal" the digits sit at a different height in every system font (cut off in Safari) */
.cardNumber {
    position: absolute;
    top: -22px;
    line-height: 1;
    font-size: 11em;
    margin: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    font-weight: 800;
    color: white;
    z-index: 10;
    transition: opacity .3s, transform .45s cubic-bezier(.694, .048, .335, 1), -webkit-transform .45s cubic-bezier(.694, .048, .335, 1);
    transform: translateY(15px);
    transition-delay: 0.5s;
    opacity: 0;
    -webkit-transition: opacity .3s, transform .45s cubic-bezier(.694, .048, .335, 1), -webkit-transform .45s cubic-bezier(.694, .048, .335, 1);
    -moz-transition-delay: 0.5s;
    -webkit-transition-delay: 0.5s;
    -o-transition-delay: 0.5s;
}

.workCard:hover .cardNumber {
    opacity: 1;
    transform: translateY(0);
    -webkit-animation-delay: 0.4s;
}


@media (max-width: 1000px) {
    .workCard {
        width: calc(100vw - 32px);
        height: 360px;
    }

    .cardSlot {
        margin: 24px 0;
    }

    .cardLeft, .cardRight {
        left: 0;
    }

    .textLeft {
        left: 24px;
    }

    .textRight {
        right: 24px;
    }

    .cardTitle {
        font-size: 2em;
    }

    /* the arrow sits to the right of the button, keep it inside the card */
    .textRight .btnContainer {
        margin-right: 50px;
    }
}
